import React from "react";
import {BooleanInput, SimpleForm, TextInput} from "react-admin";
import {FormProps} from "../../shared/types";
import {initInput} from "../../shared/utils";
import {ColorInput} from "../../components/ColorInput";
import {useOptions} from "../../shared/hooks/useOptions";

export const PresenceZoneForm = (props: FormProps) => {

  const { data: options } = useOptions("presence_zones", "GET");

  return (
    options ?
      <SimpleForm
        {...props}
      >
        <TextInput {...initInput("properties.name", props.fieldOptions, props.canEdit)} label={"None zona"} />

        <BooleanInput {...initInput("properties.qr_required", props.fieldOptions, props.canEdit)} label={"Qr richiesto per ingresso"} />

        <ColorInput source="properties.color" label="Colore" />

        <TextInput {...initInput("properties.tags", props.fieldOptions, props.canEdit)} label="Tags" />
      </SimpleForm> : null
  );
};
